import {ProtectedGroupResponseBody} from '@dms/api/security';

/**
 * Ids of every protected unit in the given permission tree, in tree order.
 */
export const collectProtectedUnitIds = (resources: ProtectedGroupResponseBody[]): string[] =>
  resources.flatMap((resource) => [
    ...resource.protectedUnits.map((protectedUnit) => protectedUnit.id),
    ...collectProtectedUnitIds(resource.children),
  ]);
